import React from "react";
import "../styles/valuesPage.css";
import { FaHandsHelping, FaLightbulb, FaUsers, FaLeaf } from "react-icons/fa";

const values = [
  {
    icon: <FaHandsHelping />,
    title: "Empowerment",
    description:
      "We equip individuals with skills, knowledge, and opportunities to rise above challenges and shape their own future.",
  },
  {
    icon: <FaLightbulb />,
    title: "Innovation",
    description:
      "We embrace creative solutions and forward-thinking approaches to solve social challenges effectively.",
  },
  {
    icon: <FaUsers />,
    title: "Community",
    description:
      "We build strong, supportive communities that collaborate and uplift one another.",
  },
  {
    icon: <FaLeaf />,
    title: "Sustainability",
    description:
      "We promote initiatives that are environmentally responsible and socially sustainable for long-term impact.",
  },
];

const ValuesPage = () => {
  return (
    <div className="values-page">
      <header className="values-header">
        <h1>Our Core Values</h1>
        <p>
          Through Tuwe Initiative, we aim to create a world where resilience
          meets opportunity, unlocking the potential of every individual to rise
          above adversity and contribute to a thriving, equitable society.
        </p>
      </header>

      <div className="values-container">
        {values.map((value, index) => (
          <div key={index} className="value-card">
            <div className="icon">{value.icon}</div>
            <h3>{value.title}</h3>
            <p>{value.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ValuesPage;
